export const typeList = [
  { value: "EXCHANGE_RATE", icon: "ios-swap" },
  { value: "MAINTAINER", icon: "ios-hammer" },
  { value: "OTHERS", icon: "ios-flag" },
  { value: "REFERENCE_FILE", icon: "ios-paper" }
]
